<template>
  <div
    v-loading="statusLoading || operateLoading"
    class="switch-card switch-card--single"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :element-loading-text="loadingtxt"
  >
    <!-- 头部：别名 + 类型标识 + 工具 -->
    <div class="switch-card__header">
      <div class="switch-card__identity">
        <el-tooltip :content="switchInfo.alias" placement="top">
          <span class="switch-card__name">{{ switchInfo.alias }}</span>
        </el-tooltip>
        <span
          class="switch-card__state-tag"
          :class="`is-${switchInfo.groups[0].status}`"
        >{{ statusText(switchInfo.groups[0].status) }}</span>
      </div>
      <div class="switch-card__tools">
        <el-tooltip content="刷新状态" placement="top">
          <el-button
            class="switch-card__tool-btn"
            size="mini"
            circle
            icon="el-icon-refresh-right"
            @click="handleRefresh"
          />
        </el-tooltip>
        <el-tooltip content="编辑" placement="top">
          <el-button
            class="switch-card__tool-btn"
            size="mini"
            circle
            icon="el-icon-edit"
            @click="handleOpenEditDialog"
          />
        </el-tooltip>
        <el-tooltip content="删除开关" placement="top">
          <el-button
            class="switch-card__tool-btn switch-card__tool-btn--danger"
            size="mini"
            circle
            icon="el-icon-delete"
            @click="handleDelete"
          />
        </el-tooltip>
      </div>
    </div>

    <div class="switch-card__status">
      <span
        class="switch-card__lamp"
        :class="`is-${switchInfo.groups[0].status}`"
      />
      <span
        class="switch-card__status-label"
        :class="`is-${switchInfo.groups[0].status}`"
      >{{ statusText(switchInfo.groups[0].status) }}</span>
    </div>

    <div class="switch-card__meta">
      <div class="switch-card__meta-row">
        <span class="switch-card__meta-label">采集器编号</span>
        <span class="switch-card__meta-value">{{ switchInfo.gatewaySn }}</span>
      </div>
      <div class="switch-card__meta-row">
        <span class="switch-card__meta-label">断路器地址</span>
        <span class="switch-card__meta-value">{{ switchInfo.groups[0].address }}</span>
      </div>
    </div>

    <div class="switch-card__footer">
      <el-button
        class="switch-card__operate-btn"
        type="success"
        size="small"
        round
        :disabled="switchInfo.groups[0].status === 'open'"
        @click="handleOperate('1')"
      >操作分闸</el-button>
      <el-button
        class="switch-card__operate-btn"
        type="danger"
        size="small"
        round
        :disabled="switchInfo.groups[0].status === 'close'"
        @click="handleOperate('2')"
      >操作合闸</el-button>
    </div>
  </div>
</template>

<script>

/** 开关状态字典 */
const STATUS_DICT = {
  /** 合闸 */
  close: { label: '合闸' },
  /** 分闸 */
  open: { label: '分闸' },
  /** 离线 */
  offline: { label: '离线' }
}
import { QueryChannelStatusAndIndicatorStatus, ChannelFlashOpen } from '@/api/SwitchDevice'
export default ({
  name: 'SingleSwitch',
  props: {
    switchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      /** 刷新状态loading */
      statusLoading: false,
      /** 操作loading */
      operateLoading: false,
      /** 操作loading文案 */
      loadingtxt: '',
      /** 当前操作参数 */
      currentOperate: {
        /** 操作类型 1：分闸, 2：合闸 */
        operateType: '',
        /** 操作分闸或合闸的断路器组索引 */
        groupIndex: 0
      }
    }
  },
  mounted () {
    this.handleRefresh()
  },
  methods: {
    /** 状态文案 */
    statusText (status) {
      const dict = STATUS_DICT[status]
      return dict ? dict.label : status
    },

    /** 刷新开关状态 */
    handleRefresh () {
      this.loadingtxt = '刷新状态中'
      this.statusLoading = true
      QueryChannelStatusAndIndicatorStatus({
        deviceid: this.switchInfo.deviceid,
        address: '1',
        controlIndex: '2',
        deviceModel: 'io2',
        sn: this.switchInfo.gatewaySn
      }).then(({ data }) => {
        // indicator:指示灯状态
        const { indicator } = data
        if (indicator.status === '0' && indicator.data.code === '0') {
          const { do1, do2 } = indicator.data.data
          if ((do1 === true && do2 === true) || (do1 === false && do2 === false)) {
            this.switchInfo.groups[0].status = 'offline'
            this.$message({
              message: '刷新状态失败',
              type: 'error'
            })
          } else {
            if (do1 === true) {
              this.switchInfo.groups[0].status = 'open'
            } else if (do2 === true) {
              this.switchInfo.groups[0].status = 'close'
            }
            this.$message({
              message: '刷新状态成功',
              type: 'success'
            })
          }
        } else {
          this.switchInfo.groups[0].status = 'offline'
          this.$message({
            message: '刷新状态失败',
            type: 'error'
          })
        }
        return data
      }).then(() => {
        this.statusLoading = false
        this.loadingtxt = ''
      }).catch(() => {
        this.statusLoading = false
        this.loadingtxt = ''
        this.$message({
          message: '刷新状态失败',
          type: 'error'
        })
      })
    },

    /** 打开编辑弹框 */
    handleOpenEditDialog () {
      this.$emit('openEditDialog', this.switchInfo)
    },

    /** 删除开关 */
    handleDelete () {
      this.$emit('deleteSwitch', this.switchInfo)
    },

    /**
     * 执行某一组开关操作前的状态预检
     * @param operateType  1=操作分闸 2=操作合闸
     */
    handleOperate (operateType) {
      // 离线状态不允许操作，提示刷新
      if (this.switchInfo.groups[0].status === 'offline') {
        this.$msgWarning(`「${this.switchInfo.alias}」当前处于离线状态，请尝试刷新状态后再执行此操作`)
      } else {
        if (operateType === '1' && this.switchInfo.groups[0].status === 'open') {
          this.$msgWarning(`「${this.switchInfo.alias}」当前已分闸，无需重复操作`)
        } else if (operateType === '2' && this.switchInfo.groups[0].status === 'close') {
          this.$msgWarning(`「${this.switchInfo.alias}」当前已合闸，无需重复操作`)
        } else {
          this.currentOperate.operateType = operateType
          this.currentOperate.groupIndex = '0'
          this.$emit('operateSwitchValidate', this.switchInfo, 0, operateType)
        }
      }
    },

    /** 操作码校验通过后执行操作 */
    handleOperateConfirmCall () {
      return new Promise((resolve, reject) => {
        const { operateType, groupIndex } = this.currentOperate
        if (!operateType || !groupIndex) {
          reject('操作参数错误')
        }
        const operateTxt = operateType === '1' ? '分闸' : '合闸'
        this.loadingtxt = `正在${operateTxt}，操作中`
        this.operateLoading = true
        ChannelFlashOpen({
          sn: this.switchInfo.gatewaySn,
          address: '1',
          controlIndex: operateType,
          deviceModel: 'io2',
        }).then((response) => {
          const { status, data } = response
          if (status === '0') {
            if (data.code === '0') {
              window.setTimeout(() => { this.handleRefresh() }, 1000)
              this.currentOperate.operateType = ''
              resolve()
            } else {
              this.$message({
                message: `操作${operateTxt}失败`,
                type: 'error'
              })
              reject(`操作${operateTxt}失败`)
            }
          } else {
            this.$message({
              message: `操作${operateTxt}失败`,
              type: 'error'
            })
            reject(`操作${operateTxt}失败`)
          }
        }).catch(() => {
          this.$message({
            message: `操作${operateTxt}失败`,
            type: 'error'
          })
          reject(`操作${operateTxt}失败`)
        }).finally(() => {
          this.operateLoading = false
          this.loadingTxt = ""
        })
      })
    }
  }
})
</script>
